module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjE2MSIgaGVpZ2h0PSIxLjUwMDAxIiB2aWV3Qm94PSIwIDAgMTYxIDEuNTAwMDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSIxIj4KPHBhdGggaWQ9IlZlY3RvciA2NCIgb3BhY2l0eT0iMC41IiBkPSJNMC41IDAuNTAwMDE0TDE2MC41IDAuNSIgc3Ryb2tlPSIjM0ZCQjcwIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtZGFzaGFycmF5PSIyIDIiLz4KPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/basicLevel/stepper_line_active.svg
// module id = E6Bi
// module chunks = 1